import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

const AddOfer2 = ({styles, handleSubmit, handleChange, args, errors}) => {
    const actInact = false
    return(
        <div>
            <button className="ui right labeled icon button" style={styles.titBuscar}>
                <i className="large plus yellow icon"></i>
                Oferta nueva
            </button>
            <div style={styles.box}>
                <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
                    <div className="ui one column stackable grid">
                        <div className="row container">
                            <div className="column" width="100%">
                                <Form.Field>
                                    <label style={styles.label}>Código</label>
                                    <Form.Input autoComplete="off" name="codigoOferta" id="codigoOferta" onChange={handleChange} placeholder='Código' icon={!errors.length?null: _find(errors, {path:'codigoOferta'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                </Form.Field>
                                <Form.Field>
                                    <label style={styles.label}>Descripción</label>
                                    <Form.Input autoComplete="off" name="descrOferta" id="descrOferta" onChange={handleChange} placeholder='Descripción' icon={!errors.length?null: _find(errors, {path:'descrOferta'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                </Form.Field>
                                <Form.Field>
                                    <label style={styles.label}>Inactiva / Activa</label>
                                    <Form.Checkbox defaultChecked={actInact} name="estadoOferta" id="estadoOferta" className='ui fitted toggle checkbox' onChange={handleChange}/>
                                </Form.Field>

                                <Button style={styles.confirmar} type='submit' fluid>
                                    AGREGAR
                                </Button>

                                {
                                    errors.length?<Message negative header="Los siguientes errores:"
                                    list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                                }
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default AddOfer2
